<div class="celebration-dialog text-center">
  <div class="celebration-confetti" aria-hidden="true">
    <span
      *ngFor="let piece of confetti"
      class="celebration-confetti-piece"
      [style.left.%]="piece.left"
      [style.background-color]="piece.color"
      [style.animation-delay.ms]="piece.delay"
      [style.animation-duration.ms]="piece.duration"
    ></span>
  </div>

  <div class="celebration-badges d-flex flex-wrap justify-content-center mb-6">
    <div
      class="celebration-badge text-center"
      *ngFor="let badge of preview; let i = index"
      [@badgePop]="{ value: '', params: { delay: i * 120 } }"
    >
      <span class="celebration-glow"></span>
      <app-badge-tile [badge]="badge" [size]="single ? 'lg' : 'md'" [earned]="true"></app-badge-tile>
      <div class="font-size-xs text-dark-75 mt-2 text-truncate" [title]="badge.name" *ngIf="!single">
        {{ badge.name }}
      </div>
    </div>
  </div>
  <div class="text-muted font-size-xs mb-4" *ngIf="hiddenCount > 0">+{{ hiddenCount }}</div>

  <ng-container *ngIf="single; else many">
    <h3 class="font-weight-bolder mb-2">{{ '::NewAchievementUnlocked' | abpLocalization }}</h3>
    <div class="font-size-h5 font-weight-bold text-dark-75 mb-1">{{ single.name }}</div>
    <div class="text-primary font-weight-bold mb-2" *ngIf="single.isMultiTier && single.tierName">
      {{ single.tierName }}
    </div>
    <p class="text-muted mb-6">{{ single.description }}</p>
  </ng-container>
  <ng-template #many>
    <h3 class="font-weight-bolder mb-6">
      {{ '::NewAchievementsUnlocked' | abpLocalization: ('' + state.badges.length) }}
    </h3>
  </ng-template>

  <div class="celebration-actions">
    <button type="button" class="btn btn-primary font-weight-bold" (click)="seeAll()">
      <i class="bi bi-trophy"></i> {{ '::SeeAllAchievements' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-light font-weight-bold" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
